<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            Neue Entnahmestelle anlegen
        </template>
                
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Bezeichnung / Kennzahl</label>
                <input type="text" v-model="label" class="form-control" @keydown="resetAlert('alert.emptyLabel')" v-bind:class="{ 'is-invalid-': alert.emptyLabel }" placeholder="Bezeichnung / Kennzahl der Entnahmestelle">
            </div>           
        </div>
        
        <Alert type="danger" :show="alert.emptyLabel" :timeout="6000">
            <template v-slot:title>Name der Wasserentnahmestelle</template>
            Bitte geben Sie einen Namen für die Wasserentnahmestelle an.
        </Alert>

        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Art der Entnahmestelle</label>
                <select v-model="waterPointType" class="form-select">
                     <option v-for="option in waterPointTypeList" v-bind:key="option.value" v-bind:value="option.value">{{ option.label }}</option>
                </select>
            </div>           
        </div>
        
        <transition name="fade">
        <div v-show="isWell" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Gestattung pro Jahr</label>
                <FloatInput v-model:value="maxWithdrawal" :imaskOptions="{mask:'0[00000] m³',overwrite: true, lazy:false}"
                :digits="3" placeholder="Gestattete Entnahmemenge in m³" >
                </FloatInput>
            </div>           
        </div>
        </transition>
        
        <Alert type="danger" :show="alert.emptyMaxWithdrawal" :timeout="6000">
            <template v-slot:title>Gestattung pro Jahr</template>
            Bitte geben Sie die jährlich maximal gestattete Entnahmemenge des Brunnens in m³ an
        </Alert>
        
        <transition name="fade">
        <div v-show="isWell" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Messpunkthöhe über Normalhöhennull (NHN)</label>
                <FloatInput v-model:value="gaugeMark" :imaskOptions="{mask:'0[000]{,}00 m',overwrite: true, lazy:false}"
                :digits="3" placeholder="Messpunkthöhe über Normalhöhennull in m" >
                </FloatInput>
            </div>           
        </div>
        </transition>
        
        <Alert type="danger" :show="alert.emptyGaugeMark" :timeout="6000">
            <template v-slot:title>Messpunkthöhe über Normalhöhennull (NHN)</template>
            Bitte geben Sie die Messpunkthöhe des Brunnens über Normalhöhennull in Meter an
        </Alert>
        
        <transition name="fade">
        <div v-show="isWell" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Position der Messmarke</label>
                <input type="text" v-model="gaugeMarkPosition" class="form-control" @keydown="resetAlert('alert.emptyGaugeMarkPosition')" v-bind:class="{ 'is-invalid-': alert.emptyGaugeMarkPosition }" placeholder="Position, z.B. Brunnenoberkante">
            </div>           
        </div>
        </transition>
        
        <Alert type="danger" :show="alert.emptyGaugeMarkPosition" :timeout="6000">
            <template v-slot:title>Position der Messmarke am Brunnen</template>
            Bitte geben Sie die Position der Messmarke am Brunnen an z.B. Brunnenoberkante
        </Alert>
        
        <div class="row mt-3 mb-2">
            <div class="col-12">
            <label class="form-label">Position (Breite Nord/Länge Ost)</label>
            <GeoLocationInput v-model:latitude="position.latitude" v-model:longitude="position.longitude"></GeoLocationInput>
            </div>           
        </div>
        
        <Alert type="danger" :show="alert.emptyGeoLocation" :timeout="6000">
            <template v-slot:title>Standort</template>
            Bitte geben Sie einen Standort für die Wasserentnahmestelle an.
        </Alert>
                
        <template v-slot:footer>
            <a href="#" class="btn btn-light link-secondary" @click="closeModal" >
                Abbrechen
            </a>
            <a href="#" class="btn btn-info ms-auto" @click="submit">
              <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                Entnahmestelle anlegen
            </a>
        </template>
    </Modal>
</template>

<script>

import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';
import GeoLocationInput from '@/components/input/GeoLocationInput.vue';
import { waterPointTypeList } from '@/components/waterpoint/WaterPointItem.vue';
import FloatInput from '@/components/input/FloatInput.vue';


export default {
    name: 'New Profile Modal',
    components: {
        Modal,
        Alert,
        FloatInput,
        GeoLocationInput
    },
    inject: [
        'state',
        'config'
    ],
    props: {
       
    },
    data: function () {
        return {
            label: '',
            waterPointType: null,
            maxWithdrawal: null,
            gaugeMark: null,
            gaugeMarkPosition: null,
            position: {
                latitude: null,
                longitude: null
            },
            year: 0,
            alert: {
                emptyMaxWithdrawal: false,
                emptyGaugeMark: false,
                emptyGaugeMarkPosition: false,
                emptyLabel: false,
                emptyGeoLocation: false
            }
        }
    },
    computed: {
        waterPointTypeList: function () {
            return waterPointTypeList;
        },
        isWell: function () {
            return (
                waterPointTypeList.length > 0 && 
                waterPointTypeList[0].value === this.waterPointType
            );
        }
    },
    methods: {
        submit: function () {
           
            if (this.validateForm()) {
                this.$emit('submit', 
                    this.label, 
                    this.waterPointType, 
                    this.position, 
                    this.maxWithdrawal,
                    this.gaugeMark,
                    this.gaugeMarkPosition
                );
                this.closeModal();
            }
        },
        openModal: function () {
            this.label = '';
            this.waterPointType = this.waterPointTypeList[0].value;
            this.position.latitude = null;
            this.position.longitude = null;
            
            this.$refs.modal.openModal();            
        },
        closeModal: function () {
            this.$refs.modal.closeModal();            
        },
        resetAlert: function (alert) {
            this[alert] = false;
        },
        validateForm: function () {
           
           this.alert.emptyLabel = false;
           if ( String(this.label).trim() === '' ) {
                this.$nextTick(function() { 
                    this.alert.emptyLabel = true;
                });
                return false;
           }
           
           this.alert.emptyMaxWithdrawal = false;
           if ( this.isWell && !this.maxWithdrawal ) {
                this.$nextTick(function() { 
                    this.alert.emptyMaxWithdrawal = true;
                });
                return false;
           }
           
           this.alert.emptyGaugeMark = false;
           if ( this.isWell && !this.gaugeMark ) {
                this.$nextTick(function() { 
                    this.alert.emptyGaugeMark = true;
                });
                return false;
           }
           
           this.alert.emptyGaugeMarkPosition = false;
           if ( this.isWell && (!this.gaugeMarkPosition || String(this.gaugeMarkPosition).trim() === '') ) {
                this.$nextTick(function() { 
                    this.alert.emptyGaugeMarkPosition = true;
                });
                return false;
           }
           
           this.alert.emptyGeoLocation = false;
           if ( this.position.latitude === null || this.position.longitude === null ) {
                this.$nextTick(function() { 
                    this.alert.emptyGeoLocation = true;
                });
                return false;
           }

           return true;
        }
    },
    watch: {
        isWell: function (new_value, old_value) {
            if (old_value === true && new_value === false) {
                this.maxWithdrawal = null;
                this.gaugeMark = null;
                this.gaugeMarkPosition = null;
            } 
        }
    },
    created: function () {
        
    },
    mounted: function () {
        
    }
}
</script>